import { render, staticRenderFns } from "./CostType.vue?vue&type=template&id=a34db6e0"
import script from "./CostType.vue?vue&type=script&setup=true&lang=js"
export * from "./CostType.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend.kantoor/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports